import React from 'react';
import "./MutualFund.css"


function ELSS() {



  return (
    <>
    
    <div className='div69'>
    <div className='iframe'>
    <iframe width="560" height="315" 
    src="https://www.youtube.com/embed/27r-_oO9dPc" title="YouTube video player"
     frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
    allowfullscreen></iframe>
<div class="credit-container">
<p class="credit-text">
      Powered by <a class="credit-link" href="https://www.mutualfundssahihai.com/en/what-is-a-mutual-fund">Mutual Fund Sahi Hai</a></p>
</div>
</div>



       <div className='description' >
       
        <h2 className='Simplifying_elss'>
        ELSS Fund – Tax Saving Mutual Fund
        </h2>
      
     

        An ELSS is an Equity Linked Savings Scheme, that allows an individual or HUF a deduction from total income of up to Rs. 1.5 lacs under Sec 80C of Income Tax Act 1961.        <br />
        <br />
        Thus if an investor was to invest Rs. 50,000 in an ELSS, then this amount would be deducted from the total taxable income, thus reducing her tax burden.        <br />
        <br />
        These schemes have a lock-in period of three years from date of units allotment. After the lock-in period is over, the units are free to be redeemed or switched. ELSS offer both growth and dividend options. Investors can also invest through Systematic Investment Plans (SIP), and investments up to ₹ 1.5 lakhs, made in a financial year are eligible for tax deduction        <br />
        <br/>
        When an investor puts money into an ELSS, the invested amount is deducted from their total taxable income. This deduction can be claimed up to a maximum of Rs. 1.5 lakhs in a financial year.        <br />
        <br />
        ELSS has a lock-in period of three years from the date of allotment of units. This means that investors cannot redeem or sell their units before the completion of the lock-in period.        <br />
        <br />
        ELSS funds offer both growth and dividend options. Under the growth option, the investor's returns are accumulated over time, and they can redeem the units at the end of the lock-in period. In the dividend option, investors receive regular dividend payouts during the lock-in period.        <br />
        <br />
        An individual or a Hindu Undivided Family (HUF) can claim a deduction of up to Rs. 1.5 lakhs from their total taxable income in a financial year by investing in ELSS.
        <br/>
        When an investor puts money into an ELSS, the invested amount is deducted from their total taxable income. This means that the investor's taxable income is reduced by the amount invested in ELSS, up to the maximum deduction limit of Rs. 1.5 lakhs.
 

</div>



</div>

<div className='points'>

  
</div>

    </>
);
}
export default ELSS;